export const VieErrorMessageConstant = {
  NotExistEmail: 'Email không tồn tại trong hệ thống.',
  AlreadyExistEmail: 'Email đã tồn tại trong hệ thống.',
  AlreadyExistCitizenNumber: 'Số căn cước công dân đã tồn tại trong hệ thống.',
  InvalidKitchenCenterId: 'Id bếp trung tâm không phù hợp với id trong hệ thống.',
  InvalidBrandId: 'Id thương hiệu không phù hợp với id trong hệ thống.',
  InvalidStoreId: 'Id cửa hàng không phù hợp với id trong hệ thống.',
  InvalidCategoryId: 'Id danh mục không phù hợp với id trong hệ thống.',
  InvalidBankingAccountId: 'Id tài khoản ngân hàng không phù hợp với id trong hệ thống.',
  InvalidCashierId: 'Id nhân viên thu ngân không phù hợp với id trong hệ thống.',
  InvalidProductId: 'Id sản phẩm không phù hợp với id trong hệ thống.',
  IdNotSuitable: 'Id không phù hợp với id trong hệ thống.',
  KitchenCenterIdNotSuitable: 'Id bếp trung tâm không phù hợp với id trong hệ thống.',
  BrandIdNotSuitable: 'Id thương hiệu không phù hợp với id trong hệ thống.',
  CategoryIdNotSuitable: 'Id danh mục không phù hợp với id trong hệ thống.',
  ProductIdNotSuitable: 'Id sản phẩm không phù hợp với id trong hệ thống.',
  NotExistKitchenCenterId: 'Id bếp trung tâm không tồn tại trong hệ thống.',
  NotExistKitchenCenter: 'Trung tâm bếp không tồn tại trong hệ thống.',
  NotExistBrandId: 'Id thương hiệu không tồn tại trong hệ thống.',
  NotExistStoreId: 'Id cửa hàng không tồn tại trong hệ thống.',
  NotExistCategoryId: 'Id danh mục không tồn tại trong hệ thống.',
  NotExistBankingAccountId: 'Id tài khoản ngân hàng không tồn tại trong hệ thống.',
  NotExistProductId: 'Id sản phẩm không tồn tại trong hệ thống.',
  NotExistOrderPartnerId: 'Id đơn hàng của đối tác không tồn tại trong hệ thống.',
  NotExistCashierId: 'Id nhân viên thu ngân không tồn tại trong hệ thống.',
  InvalidItemsPerPage: 'Các mục trên mỗi trang được yêu cầu lớn hơn 0.',
  InvalidCurrentPage: 'Số trang hiện tại phải lớn hơn 0.',
  NotExistPartnerId: 'Id đối tác không tồn tại trong hệ thống.',
  NotExistAccountId: 'Id tài khoản không tồn tại trong hệ thống.',
  InvalidPartnerId: 'Id đối tác không phải là id phù hợp trong hệ thống.',
  CategoryIdNotBelongToBrand: 'Id danh mục không thuộc về thương hiệu của bạn.',
  CategoryIdNotBelongToStore: 'Id danh mục không thuộc về cửa hàng của bạn.',
  AlreadyExistPartnerProduct: 'Sản phẩm đối tác đã tồn tại trong hệ thống.',
  NotExistPartnerProduct: 'Sản phẩm đối tác không tồn tại trong hệ thống.',

  DisabledAccount: 'Tài khoản đã bị vô hiệu hóa.',
  InvalidEmailOrPassword: 'Email hoặc Mật khẩu không hợp lệ.',

  AccountIdNotBelongYourAccount: 'Id tài khoản không thuộc về tài khoản của bạn.',
  AccountNoLongerActive: 'Tài khoản của bạn không còn hoạt động.',

  NotAuthenticatedEmailBefore: 'Email chưa được xác thực trước đó.',
  ExpiredOTPCode: 'Mã OTP đã hết hạn.',
  NotMatchOTPCode: 'Mã OTP của bạn không khớp với mã OTP đã gửi trước đó.',

  InvalidAccessToken: 'Mã truy cập không hợp lệ',
  NotExpiredAccessToken: 'Mã truy cập vẫn chưa hết hạn.',
  NotExistAuthenticationToken: 'Bạn không có mã xác thực trong hệ thống.',
  NotExistRefreshToken: 'Mã xác thực làm mới không tồn tại trong hệ thống.',
  NotMatchAccessToken: 'Mã truy cập của bạn không khớp với mã truy cập đã đăng ký.',
  ExpiredRefreshToken: 'Mã làm mới đã hết hạn.',

  NotAuthenticatedEmail: 'Email chưa được xác thực trước đó.',
  NotVerifiedEmail: 'Email chưa được xác thực bằng mã OTP đã gửi trước đó.',

  DeactiveKitchenCenter_Update: 'Bếp trung tâm đã bị xóa trước đó nên không thể cập nhật bếp trung tâm này.',
  KitchenCenterManagerEmailExisted: 'Email quản lý bếp trung tâm đã tồn tại trong hệ thống.',
  ExistedActiveStores_Delete: 'Bếp trung tâm có các cửa hàng đang hoạt động nên không thể xóa bếp trung tâm này.',
  NotBelongToKitchenCenter: 'Id bếp trung tâm không thuộc về bếp trung tâm của bạn.',
  NoOneKitchenCenterAvailable: 'Không có sẵn bếp trung tâm.',

  InvalidStatusFilter: 'Bộ lọc trạng thái bắt buộc là HOẠT ĐỘNG, KHÔNG HOẠT ĐỘNG trong hệ thống.',
  NotBelongToBrand: 'Id thương hiệu không thuộc về thương hiệu của bạn.',
  DeactiveBrand_Delete: 'Thương hiệu không thể xóa vì đã bị xóa trước đó.',
  DeactiveBrand_Update: 'Thương hiệu đã bị xóa trước đó nên thương hiệu này không thể cập nhật.',
  BrandManagerEmailExisted: 'Email quản lý thương hiệu đã tồn tại trong hệ thống.',
  RoleNotSuitable: 'Vai trò không phù hợp',
  ProductNotBelongToBrand: 'Sản phẩm này không thuộc về thương hiệu.',
  KeySortNotExist: 'Sắp xếp khóa là ASC hoặc DESC',

  BrandNotJoinKitchenCenter: 'Thương hiệu không tham gia vào bếp trung tâm.',
  KitchenCenterNotHaveBrand: 'Bếp trung tâm không có thương hiệu này.',
  BrandNotHaveStore: 'Thương hiệu không có cửa hàng này trong hệ thống.',
  KitchenCenterNotHaveStore: 'Bếp trung tâm không có cửa hàng này trong hệ thống.',
  DeactiveStore_Update: 'Cửa hàng đã bị xóa trước đó nên cửa hàng này không thể cập nhật.',
  DeactiveStore_Delete: 'Cửa hàng không thể xóa vì đã xóa trước đó.',
  ManageremailExisted: 'Email quản lý cửa hàng đã tồn tại trong hệ thống.',
  NotConfirmingStore: 'Cửa hàng không phải là cửa hàng mới để xác nhận trở thành cửa hàng HOẠT ĐỘNG.',
  NotRejectedResonForNewStore: 'Việc đăng ký cửa hàng bị từ chối phải có lý do.',
  StoreIdDoesNotExisted: 'Id cửa hàng không tồn tại trong hệ thống.',
  StoreIdNotBelongToStore: 'Id cửa hàng không thuộc về cửa hàng của bạn.',
  StoreIdNotBelongToBrand: 'Id cửa hàng không thuộc về thương hiệu của bạn.',
  StoresWithStatusNameParam:
    'Một số loại trạng thái được yêu cầu như: Đang hoạt động, Không hoạt động, Bị từ chối, Đang xác nhận.',

  CategoryCodeExistedInBrand: 'Mã danh mục đã tồn tại trong thương hiệu.',
  CategoryCodeExisted: 'Mã danh mục đã tồn tại trong hệ thống.',
  DeactiveCategory_Delete: 'Danh mục không thể xóa vì đã bị xóa trước đó.',
  DeactiveCategory_Update: 'Danh mục đã bị xóa trước đó nên danh mục này không thể cập nhật.',
  InvalidCategoryType: 'Loại là bắt buộc.',
  NotExistCategoryType: 'Loại được yêu cầu NORMAL hoặc EXTRA.',
  StatusInvalid: 'Trạng thái là HOẠT ĐỘNG hoặc KHÔNG HOẠT ĐỘNG.',
  CategoryMustBeNormal: 'CategoryId phải là loại NORMAL.',
  ExtraCategoryGreaterThan0: 'Id danh mục bổ sung phải lớn hơn 0.',
  ListExtraCategoryIdIsExtraType: 'Danh sách Id danh mục extra cần phải là loại EXTRA.',
  ListExtraCategoryIdIsActive: 'Danh sách Id danh mục extra cần có trạng thái HOẠT ĐỘNG.',
  ExtraCategoryIdNotBelongToBrand: 'Id danh mục extra không thuộc về thương hiệu.',
  ExtraCategoryIdDoesNotExist: 'Id danh mục extra không tồn tại trong hệ thống.',

  BankingAccountNotBelongToKitchenCenter: 'Bếp trung tâm của bạn không có id tài khoản ngân hàng này.',
  NumberAccountExisted: 'Số tài khoản đã tồn tại trong hệ thống.',
  BankingAccountIsInactive: 'Tài khoản ngân hàng không còn hoạt động.',

  ProductCodeExistedInBrand: 'Mã đã tồn tại trong thương hiệu.',
  ProductCodeExisted: 'Mã đã tồn tại trong hệ thống.',
  ParentProductIdNotExist: 'Id sản phẩm cha không tồn tại trong hệ thống.',
  ParentProductIdNotBelongToBrand: 'Id sản phẩm cha không thuộc về thương hiệu của bạn.',
  CategoryNotSuitableForSingleOrParentProductType:
    'Id danh mục không phải là loại phù hợp cho loại sản phẩm SINGLE hoặc PARENT.',
  CategoryNotSuitableForEXTRAProductType: 'Id danh mục không phải là loại phù hợp cho loại sản phẩm EXTRA.',
  CategoryIdNotBelongToKitchenCenter: 'Bếp trung tâm của bạn không thể nhận được sản phẩm có id danh mục này.',
  InvalidProductType: 'Loại sản phẩm bắt buộc phải có một số loại như: SINGLE, PARENT, CHILD, EXTRA.',
  ProductIdNotBelongToBrand: 'Id sản phẩm không thuộc về thương hiệu của bạn.',
  ProductNotBelongToStore: 'Id sản phẩm không thuộc về cửa hàng của bạn.',
  ProductNotSpendToStore: 'Id sản phẩm không dành cho bếp trung tâm của bạn.',
  ProductNameNotFollowingFormat:
    "Tên sản phẩm loại CHILD bắt buộc phải có định dạng sau: 'ParentName - Size x' Với x là kích thước bạn đã chọn.",
  ProductNameTypeChildNotAllowUpdate: 'Tên sản phẩm thuộc loại CHILD không cho phép cập nhật.',
  ProductIdNotParentType: 'Id sản phẩm không phải là loại PARENT.',
  InvalidProductTypeParent: 'Không hợp lệ đối với loại sản phẩm: PARENT.',
  InvalidProductTypeChild: 'Không hợp lệ đối với loại sản phẩm: CHILD.',
  InvalidProductTypeSingle: 'Không hợp lệ đối với loại sản phẩm: SINGLE.',
  InvalidProductTypeExtra: 'Không hợp lệ đối với loại sản phẩm: EXTRA.',
  InvalidOnField: 'Trường không hợp lệ',

  DupplicatedPartnerName: 'Tên đối tác đã tồn tại trong hệ thống.',
  DupplicatedWebUrl: 'Url Web đã tồn tại trong hệ thống.',
  DeactivePartner_Update: 'Đối tác đã bị xóa trước đó nên đối tác này không thể cập nhật.',
  DeactivePartner_Delete: 'Đối tác không thể xóa vì đã bị xóa trước đó.',
  DeactivePartner_Get: 'Đối tác không thể nhận được vì đã bị xóa trước đó.',
  PartnerHasPartnerStoreActive_Update:
    'Đối tác không thể cập nhật trạng thái vì các cửa hàng đang hoạt động đang sử dụng đối tác này.',
  PartnerHasPartnerStoreActive_Delete: 'Không thể xóa đối tác vì các cửa hàng đang hoạt động đang sử dụng đối tác này.',

  CashierIdNotBelongToKitchenCenter: 'Id nhân viên thu ngân không thuộc về trung tâm nhà bếp của bạn.',
  CashierIdNotBelogToCashier: 'Id nhân viên thu ngân không phù hợp với tài khoản của bạn.',
  StatusIsRequiredWithKitchenCenterManager: 'Trạng thái không rỗng',
  StatusIsNotRequiredWithCashier: 'Nhân viên thu ngân không cho phép cập nhật thuộc tính Trạng thái.',
  NoOneCashierAvailable: 'Không có sẵn nhân viên thu ngân.',

  InactiveStore_Create: 'Cửa hàng này đã không hoạt động hoặc bị vô hiệu hóa.',
  StoreNotBelongToBrand: 'Cửa hàng không thuộc về thương hiệu.',
  LinkedWithParner: 'Cửa hàng này đã được liên kết với đối tác này.',
  UsernameExisted: 'Tên người dùng đã tồn tại trong hệ thống.',
  NotLinkedWithParner: 'Cửa hàng này không được liên kết với đối tác này và nó vẫn hoạt động.',
  DeactiveStorePartner_Update: 'Không thể cập nhật đối tác cửa hàng đã bị vô hiệu hóa.',
  DupplicatedPartnerId_Create: 'Id đối tác không thể trùng lặp trong danh sách Tài khoản đối tác.',
  GrabFoodAccountMustBeStoreManager: 'Tài khoản GrabFood phải có vai trò Quản lý cửa hàng.',
  ItemOnGrabfoodCanNotMapping: 'Mặt hàng trên GrabFood không thể ánh xạ tới bất kỳ sản phẩm nào trong Hệ thống MBKC.',
  ModifierGroupOnGrabfoodCanNotMapping:
    'Nhóm sửa đổi trên GrabFood không thể ánh xạ tới bất kỳ sản phẩm nào trong Hệ thống MBKC.',
  BrandHasNoActiveProduct: 'Thương hiệu không có sản phẩm đang hoạt động',
  ParentProductMappingNotYet: 'Bạn cần ánh xạ sản phẩm cha trước khi ánh xạ sản phẩm này.',

  ProductCodeExistedInTheSystem: 'Mã sản phẩm đã tồn tại trong hệ thống.',
  DeactiveProduct_Create_Update: 'Sản phẩm này đã ngừng hoạt động.',
  InactiveProduct_Create_Update: 'Sản phẩm này không hoạt động.',
  InactiveStore_Update: 'Cửa hàng này đã không hoạt động.',

  StatusInValid: 'Trạng thái phải là AVAILABLE, OUT_OF_STOCK_TODAY or OUT_OF_STOCK_INDENTIFINITELY.',
  ProductCodeNotExistInGrabFoodSystem: 'Mã sản phẩm không tồn tại trên Hệ thống GrabFood.',
  PriceNotMatchWithProductInGrabFoodSystem: 'Giá không khớp với sản phẩm trong Hệ thống GrabFood.',
  StatusNotMatchWithProductInGrabFoodSystem: 'Trạng thái không khớp với trạng thái sản phẩm trong Hệ thống GrabFood.',
  ProductPartnerNotAvailableNow: 'Sản phẩm của đối tác hiện không có sẵn.',
  ProductPriceNotMatchWithPartnerProduct: 'Giá sản phẩm không phù hợp với sản phẩm của đối tác.',
  ExtraProductPriceNotMatchWithPartnerProduct: 'Giá sản phẩm extra không khớp với sản phẩm của đối tác.',
  NoOneOutOfStock: 'Không có sản phẩm đối tác nào hết hàng.',
  UpdatePartnerProductSuccessfully: 'Thay đổi trạng thái sản phẩm của đối tác thành công.',

  OrderNotBelongToKitchenCenter: 'Id đặt hàng đối tác không thuộc trung tâm bếp của bạn.',
  OrderShipperPhoneNotMatch: 'Điện thoại của người gửi không khớp với số điện thoại của người gửi theo thứ tự.',
  OrderIsPreparing: 'Đơn hàng này đang ở trạng thái ĐANG CHUẨN BỊ nên Bạn không thể xác nhận đơn hàng đã hoàn thành.',
  OrderIsReady: 'Đơn hàng này ở trạng thái SẴN SÀNG nên Bạn không thể xác nhận đơn hàng đã hoàn thành.',
  OrderIsUpcoming: 'Đơn hàng này đang ở trạng thái SẮP TỚI nên Bạn không thể xác nhận đơn hàng đã hoàn thành.',
  OrderIsCompleted: 'Đơn hàng này đã ở trạng thái HOÀN THÀNH nên Bạn không thể xác nhận đơn hàng đã hoàn thành.',
  OrderIsCancelled: 'Đơn hàng này đã ở trạng thái HỦY nên Bạn không thể xác nhận đơn hàng đã hoàn thành.',
  OrderAlreadyPaid: 'Đơn hàng này đã được thanh toán nên Bạn không thể xác nhận đơn hàng đã hoàn thành.',
  OrderPartnerIdNotExist: 'Id đặt hàng đối tác không tồn tại trong hệ thống.',
  OrderPartnerIdAlreadyExist: 'Id đặt hàng đối tác đã tồn tại trong hệ thống.',
  DisplayIdAlreadyExist: 'Id hiển thị đã tồn tại trong hệ thống.',
  ProductPartnerNotMappingBefore: 'Sản phẩm trong đơn hàng vẫn chưa được ánh xạ tới sản phẩm đối tác của cửa hàng.',
  ProductExtraPartnerNotMappingBefore:
    'Sản phẩm bổ sung trong đơn hàng Chi tiết vẫn chưa được ánh xạ tới sản phẩm bổ sung của đối tác của cửa hàng.',
  ProductInOrderNotExistInTheSystem: 'Id sản phẩm trong đơn hàng không tồn tại trong hệ thống.',
  ProductExtraInOrderDetailNotExistInTheSystem: 'Id bổ sung sản phẩm trong đơn hàng không tồn tại trong hệ thống.',
  OrderIdNotExist: 'Id đơn hàng không tồn tại trong hệ thống.',
  OrderIdNotBelongToStore: 'Id đơn hàng không thuộc về cửa hàng.',
  OrderIdNotBelongToKitchenCenter: 'Id đơn hàng không thuộc về trung tâm bếp.',
  OrderIsReady_Change_To_Ready: 'Đơn hàng này ở trạng thái SẴN SÀNG nên Bạn không thể chuyển sang trạng thái sẵn sàng.',
  OrderIsUpcoming_Change_To_Ready:
    'Đơn hàng này đang ở trạng thái SẮP TỚI nên Bạn không thể chuyển sang trạng thái sẵn sàng.',
  OrderIsCompleted_Change_To_Ready:
    'Đơn hàng này ở trạng thái ĐÃ HOÀN THÀNH nên Bạn không thể chuyển sang trạng thái sẵn sàng.',
  OrderIsCancelled_Change_To_Ready:
    'Đơn hàng này đang ở trạng thái HỦY nên Bạn không thể chuyển sang trạng thái sẵn sàng.',
  OrderIsReadyDelivery_Change_To_Ready:
    'Đơn hàng này đang ở trạng thái READY_DELIVERY nên Bạn không thể chuyển sang trạng thái sẵn sàng.',
  OrderIsPreparing_Change_To_ReadyDelivery:
    'Đơn hàng này đang ở trạng thái ĐANG CHUẨN BỊ nên Bạn không thể chuyển sang trạng thái giao hàng sẵn sàng.',
  OrderIsUpcoming_Change_To_ReadyDelivery:
    'Đơn hàng này đang ở trạng thái SẮP TỚI nên Bạn không thể chuyển sang trạng thái giao hàng sẵn sàng.',
  OrderIsCompeleted_Change_To_ReadyDelivery:
    'Đơn hàng này ở trạng thái ĐÃ HOÀN THÀNH nên Bạn không thể chuyển sang trạng thái giao hàng sẵn sàng.',
  OrderIsCancelled_Change_To_ReadyDelivery:
    'Đơn hàng này ở trạng thái Đã hủy nên Bạn không thể chuyển sang trạng thái giao hàng sẵn sàng.',
  OrderIsReadyDelivery_Change_To_ReadyDelivery:
    'Đơn hàng này đang ở trạng thái READY_DELIVERY nên Bạn không thể chuyển sang trạng thái giao hàng sẵn sàng.',
  OrderIsReady_Cancel: 'Đơn hàng này ở trạng thái SẴN SÀNG nên Bạn không thể hủy đơn hàng.',
  OrderIsCompleted_Cancel: 'Đơn hàng này ở trạng thái ĐÃ HOÀN THÀNH nên Bạn không thể hủy đơn hàng.',
  OrderIsCancelled_Cancel: 'Đơn hàng này ở trạng thái HỦY nên Bạn không thể hủy đơn hàng.',
  OrderIsReadyDelivery_Cancel: 'Đơn hàng này ở trạng thái READY_DELIVERY nên Bạn không thể hủy đơn hàng.',
  NoChangeOrderStatusWhenClosedShift: 'Hôm nay bạn đã đóng ca nên không thể thay đổi trạng thái.',
  NoChangeOrderStatusNotToday:
    'Chỉ có thể thay đổi trạng thái đơn hàng của ngày hôm nay. Lệnh này không phải từ hôm nay.',

  BalanceIsInvalid: 'Số dư của bạn không đủ để chuyển tiền.',

  StoreIdNotBelogToKitchenCenter: 'Id cửa hàng không thuộc trung tâm bếp của bạn.',
  StoreBalanceIsInvalid: 'Số dư cửa hàng này không hợp lệ.',
  BalanceDoesNotEnough: 'Cửa hàng này không có đủ số dư để rút tiền.',
  AlreadyTransferredToStore: 'Hôm nay tiền đã được chuyển vào cửa hàng.',
  AlreadyTransferredToKitchenCenter: 'Hôm nay tiền đã được chuyển về trung tâm bếp ăn.',
  TransferToStoreSuccessfully: 'Chuyển tiền về kho thành công.',
  TransferToKitchenCenterSuccessfully: 'Chuyển tiền về trung tâm bếp thành công.',
  NotExistJobId: 'Id công việc không tồn tại trong Hệ thống MBKC.',
  ConfigDoesNotExist: 'Cấu hình để chạy tác vụ nền không tồn tại.',

  notAccessSystem: 'Bạn không có quyền truy cập vào hệ thống',

  imageIsNotNull: 'Hình ảnh không được để trống.',
  logoIsNotNull: 'Logo không được để trống.',
  avatarIsNotNull: 'Ảnh đại diện không được để trống.',
};
